import { ApiEnv } from './typings';

export function getApiEnv(): ApiEnv {
  return (process.env.API_ENV as ApiEnv) ?? 'dev';
}
